<template>
    <div
        class="error-text-wrapper"
        :class="{ active: isError }"
        data-testid="error-text"
    >
        <Position
            v-if="isError"
            y="center"
            x="start"
            class="error-text"
            :class="{ clip: clip }"
        >
            <Warning
                v-if="icon"
                :size="14"
                style="margin-right: 7px"
            />
            <span>{{ error }}</span>
        </Position>
    </div>
</template>

<script setup>
import { computed } from 'vue'

import Position from 'widget-components/components/Position/Position.vue'
import Warning from 'widget-components/atoms/svg/Warning.vue'

const props = defineProps({
    error: {
        default: undefined,
        type: [String, Boolean],
    },
    clip: Boolean,
    icon: Boolean,
})

const isError = computed(() => typeof props.error === 'string')
</script>

<style lang="sass" scoped>
@import './ErrorText.sass'
</style>
